// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__Z5b2C","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2NnbR"};